import { render } from "./checkReceiptToken.vue?vue&type=template&id=57b43dd4"
import script from "./checkReceiptToken.vue?vue&type=script&lang=js"
export * from "./checkReceiptToken.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__